module.exports = __webpack_public_path__ + "static/img/8431_phase_function_Paper_PointsHejduk_Prediction.169dd67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8431_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 5ZRJ
// module chunks = 0